export default "__VITE_ASSET__C$CsYPer__"